/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Table_Event_GroupsInputs */



/**
* | output |
* | --- |
* | "Total Event Groups" |
*
* @param {Automatic_Save_Table_Event_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_table_event_groups = /** @type {((inputs?: Automatic_Save_Table_Event_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Table_Event_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Total des groupes d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesamtzahl der Ereignisgruppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppi di eventi totali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Всего групп событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupos de eventos totales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("总事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループの合計")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुल इवेंट समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Total de grupos de eventos")
	return /** @type {LocalizedString} */ ("Total Event Groups")
});